<template>
  <!-- 员工活动集锦&历届私董会 -->
  <div class="box gamefoto">
    <div v-if="!isM">
      <div class="gf_banner bgimg" v-if="isok == 1"></div>
      <div class="gf_banner2 bgimg" v-if="isok != 1"></div>
    </div>

    <div v-if="isM">
      <div class="gfm_banner" v-if="isok == 1"></div>
      <div class="gfm_banner2" v-if="isok != 1"></div>
    </div>

    <div class="gf1">
      <div class="min_box">
        <ul class="gf_ul">
          <li v-for="item in list" :key="item.id" @click="goInfo(item)">
            <div class="hover_img">
              <img :src="item.url" alt="" />
            </div>
            <div class="gf_bottom">
              <p>{{ item.title }}</p>
              <span>{{ item.describe }}</span>
            </div>
          </li>
        </ul>
        <button
          class="m_more"
          v-if="isM && list.length > 5 && noMore"
          @click="lookMore"
        >
          展开更多
        </button>

        <p class="over_load" v-if="!noMore">—— 加载完毕 ——</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getAlbumList } from "@/api/all";
export default {
  name: "Gamefoto",
  data() {
    return {
      isok: 1, //1员工 2私董会
      datas: {
        type: 1,
        page: 1,
        limit: 10,
      },
      dec: "",
      noMore: false,
      list: [],
      isM: false,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
    this.isok = this.$route.query.isok;
    if (this.isok == 1) {
      document.title = "员工活动集锦";
    } else {
      document.title = "历届私董会";
    }
    this.datas.type = this.isok;
    this.getPic();
  },
  methods: {
    getPic() {
      getAlbumList(this.datas).then((response) => {
        response.data.length == 0
          ? (this.noMore = false)
          : (this.noMore = true);
        this.list = this.list.concat(response.data);
      });
    },
    lookMore() {
      this.datas.page++;
      this.getPic();
    },
    goInfo(item) {
      if (this.isM) {
        this.$router.push({
          path: "/Album",
          query: {
            id: item.id,
            url: item.url,
            describe: item.describe,
            title: item.title,
            time: item.create_time,
          },
        });
      } else {
        let link = this.$router.resolve({
          path: "/Album",
          query: {
            id: item.id,
            url: item.url,
            describe: item.describe,
            title: item.title,
            time: item.create_time,
          },
        });
        window.open(link.href, "_blank");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/alldetails/Gamefoto.vue